import styled from "styled-components";

export const ContainerBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;
